module.exports = __webpack_public_path__ + "img/labvida.02243783.png";